import React from 'react';

import { Typography } from '@mui/material';
import { ActionTypeToTableActionLabel } from 'app/shared/modules/LoanRoles/LoanRolesHistory/LoanRolesHistoryTable.constants';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HistoryFallback } from 'constants/history';

export const loanRolesHistoryConfig = {
  date: {
    label: 'Date',
    width: '23%',
    colSpan: ({ date }) => date?.colSpan,
    content: ({ date }) =>
      date.content ?? (
        <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
          {dayjs(date).format(COMMON_DATETIME_FORMAT)}
        </Typography>
      ),
  },
  roleName: {
    label: 'Loan Role',
    width: '23%',
    content: ({ roleName }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {roleName}
      </Typography>
    ),
  },
  userName: {
    label: 'User',
    width: '21%',
    content: ({ userName }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {userName}
      </Typography>
    ),
  },
  modifiedBy: {
    label: 'Modified By',
    width: '20%',
    content: ({ modifiedBy }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {modifiedBy ?? HistoryFallback.SYSTEM}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: '13%',
    content: ({ action }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {ActionTypeToTableActionLabel[action]}
      </Typography>
    ),
  },
};
